import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AddressService } from '@src/app/modules/address/address.service';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { TransactionV2 } from '@src/app/shared/types/transaction.type';
import { AllChains, ChainEnum, getChainInfo } from '@src/app/shared/types/wallet-chain.type';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { Subscription } from 'rxjs';
import { TransactionCardV2Component } from '../../transaction-card-v2/transaction-card-v2.component';

@Component({
    selector: 'app-address-transactions',
    standalone: true,
    imports: [CommonModule, TransactionCardV2Component, NzSkeletonModule, SharedModule],
    templateUrl: './address-transactions.component.html',
    styleUrls: ['./address-transactions.component.less'],
})
export class AddressTransactionsComponent implements OnInit {
    @Input() walletAddress: string;
    @Input() pageType: 'address' | 'profile' = 'address';
    @Input() maxCount: number;

    realWalletAddress: string;

    chains = AllChains;

    ChainEnum = ChainEnum;

    isLastPage = false;

    currentActiveChain: ChainEnum | 'all' = 'all';

    pageState: string;
    transactions: TransactionV2[];

    fetchDataRequest$: Subscription;

    constructor(
        private addressService: AddressService,
        private walletStatusSErvice: WalletStatusService,
        public commonService: CommonService,
        public tgService: TelegramService,
        public userService: UserService
    ) {}

    ngOnInit() {
        this.realWalletAddress = this.walletAddress || this.walletStatusSErvice.walletAddress;
    }

    getChainInfo(chain: ChainEnum) {
        return getChainInfo(chain);
    }

    refresh() {
        this.pageState = null;
        this.transactions = null;
        this.isLastPage = false;
        this.fetchData();
    }

    fetchData() {
        if (this.fetchDataRequest$ && !this.fetchDataRequest$.closed) {
            this.fetchDataRequest$.unsubscribe();
        }

        this.fetchDataRequest$ = this.addressService.getAddressTransactionsV2(this.realWalletAddress, this.currentActiveChain, this.pageState).subscribe({
            next: data => {
                this.pageState = data.page_state;
                this.transactions = (this.transactions || []).concat(data.transactions);
                if (this.maxCount) {
                    this.transactions = this.transactions.slice(0, this.maxCount);
                }

                if (!this.pageState) {
                    this.isLastPage = true;
                } else {
                    if (this.maxCount && this.transactions.length >= this.maxCount) {
                        this.isLastPage = true;
                    } else if (this.transactions.length < 20) {
                        this.fetchData();
                    }
                }
            },
            error: () => {
                this.pageState = null;
                this.isLastPage = true;
            },
        });
    }
}
